import { Component, Inject } from '@angular/core';
import { OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { LoadingOrderService } from 'src/app/shared/services/loading-order.service';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import Swal from 'sweetalert2';
import { fadeInUp400ms } from 'src/@vex/animations/fade-in-up.animation';
import { Observable, ReplaySubject } from 'rxjs';
import { Router } from '@angular/router';
import { UntypedFormControl } from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { SelectionModel } from '@angular/cdk/collections';
import { stagger40ms } from 'src/@vex/animations/stagger.animation';
import { ILoadingOrder } from 'src/core/interfaces/loading-order';
import { LoadingOrderStatus } from 'src/assets/static-data/enums/loading-order-satus.enum';
import { DatePipe } from '@angular/common';
import { ICompleteDriverTripDto } from 'src/core/interfaces/IComplete-driver-trip';

@Component({
  selector: 'app-compelete-order',
  templateUrl: './compelete-order.component.html',
  styleUrl: './compelete-order.component.scss',
  providers: [DatePipe],
  animations: [fadeInUp400ms, stagger40ms]
})
export class CompeleteOrderComponent implements OnInit {
  maxQuantity: number;
  fileForm: FormGroup;
  selectedFile: File | null = null;
  fileName: string = this.translateService.instant('NO_FILE_CHOSEN.TEXT');
  isLoading: boolean;
  layoutCtrl = new UntypedFormControl('boxed');

  /**
   * Simulating a service with HTTP that returns Observables
   * You probably want to remove this and do all requests in a service with HTTP
   */

  LoadingOrders: ILoadingOrder[];
  subject$: ReplaySubject<ILoadingOrder[]> = new ReplaySubject<ILoadingOrder[]>(
    1
  );
  data$: Observable<ILoadingOrder[]> = this.subject$.asObservable();
  isInactiveLoading = false;
  clicked = false;
  lastSyncDate: Date;
  filteredDataStatus: number = -1;
  currentPage = 0;
  activeCount = 0;
  filteredDataSearch: string = null;
  isRtl: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public loadingOrder: ILoadingOrder,
    private loadingOrderService: LoadingOrderService,
    private fb: FormBuilder,
    private router: Router,
    private translateService: TranslateService,
    public dialogRef: MatDialogRef<CompeleteOrderComponent>,
    private datePipe: DatePipe
  ) {}
  pageSize = 10;
  pageSizeOptions: number[] = [5, 10, 25, 50, 100, 250, 500, 1000, 5000, 10000];
  dataSource: MatTableDataSource<ILoadingOrder> | null;
  selection = new SelectionModel<ILoadingOrder>(true, []);
  searchCtrl = new UntypedFormControl();
  itemUOM: string;

  ngOnInit(): void {
    //console.log("Loading Order", this.loadingOrder);
    this.itemUOM = this.loadingOrder.itemUOM;
    this.maxQuantity = this.loadingOrder.quantity;
    console.log('Loading Order maxQuantity', this.maxQuantity);
    this.getDriverTrips();
    this.initForm();
  }
  
  initForm() {
    this.fileForm = this.fb.group({
      file: [null, Validators.required],
      actualDeliveredQuantity: [
        null,
        [
          Validators.required,
          Validators.max(this.maxQuantity),
          Validators.min(1)
        ]
      ], // Add the ActualDeliveredQuantity field here
      // Optional Delivery Number (not required)
      deliveryNumber: [null]
    });
  }

  // Handle file selection
  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input?.files?.length) {
      this.selectedFile = input.files[0];
      this.fileName = this.selectedFile.name;
      this.fileForm.patchValue({ file: this.selectedFile });
      this.fileForm.get('file')?.updateValueAndValidity();
    }
  }

  getDriverTrips(criteria = null) {
    this.isLoading = true;
    this.loadingOrderService
      .getDriverTrips(this.currentPage, this.pageSize, true, criteria)
      .subscribe((response) => {
        console.log('Loading Orders', response.data.items);

        const documentStatusMap: { [key in LoadingOrderStatus]: string } = {
          [LoadingOrderStatus.Draft]: 'Draft',
          [LoadingOrderStatus.InProgress]: 'InProgress',
          [LoadingOrderStatus.Completed]: 'Completed',
          [LoadingOrderStatus.Synced]: 'Synced',
          [LoadingOrderStatus.Processing]: 'Processing'
        };
        const getStatusString = (status: LoadingOrderStatus): string => {
          return documentStatusMap[status];
        };
        this.LoadingOrders = response.data.items.map((order) => ({
          ...order,
          statusLabel: getStatusString(order.status),
          customerName: order.customerName ? order.customerName : 'N/A',
          factoryName: order.factoryName ? order.factoryName : 'N/A',
          InProgress: order.status === LoadingOrderStatus.InProgress,
          // isApproved: order.status === LoadingOrderStatus.Approved,
          isSynced: order.status === LoadingOrderStatus.Synced,
          isDraft: order.status === LoadingOrderStatus.Draft,
          isProcessing: order.status === LoadingOrderStatus.Processing,
          isCompeleted: order.status === LoadingOrderStatus.Completed,
          transactionDate: this.datePipe.transform(
            order.transactionDate,
            'dd/MM/yyyy' + ' | ' + 'HH:mm'
          )
        }));

        console.log(this.LoadingOrders);
        this.isLoading = false;
        this.subject$.next(this.LoadingOrders);
      });
  }

  onSubmit() {
    // // debugger;
    const formValue = this.fileForm.value;
    const CompleteDriverTripDto: ICompleteDriverTripDto = {
      deliveryAuthAttachmentFileName: this.fileName,
      deliveryAuthAttachmentFileContent: this.selectedFile,
      actualDeliveredQuantity: formValue.actualDeliveredQuantity,
      deliveryNumber:formValue.deliveryNumber,
    };
    this.loadingOrderService
      .completeDriverTrip(this.loadingOrder.id, CompleteDriverTripDto)
      .subscribe(() => {
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: this.translateService.instant(
            'LOADING_ORDER_DELIVERED_SUCCESSFULLY.TEXT'
          ),
          timer: 1500
        });

        this.dialogRef.close();
      });
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
